import { CSV_SEPARATOR, UTF8_BOM } from "./constants";
import { toCsvCell } from "./toCsvCell";

/** Builds a CSV that opens correctly in Excel. */
export const buildCsv = (rows: (string | number)[][]): string =>
  UTF8_BOM + rows.map((row) => row.map(toCsvCell).join(CSV_SEPARATOR)).join("\r\n");
